import React from "react";
import "./Home.css";
import LandingPage from "../LandingPage/LandingPage";

const Home = () => {
  return (
    <LandingPage/>
  );
};

export default Home;
